import React, { FC } from 'react';
import {
  SelectArrayInput,
  required,
  ReferenceArrayInput,
  useTranslate,
  TextInput,
} from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { JsonInput } from './JsonInput';

interface BusinessRemittancePayoutFormProps {
  keyName: string;
  basePath: string;
}
export const BusinessRemittancePayoutForm: FC<BusinessRemittancePayoutFormProps> = ({
  keyName,
  basePath,
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  const td = (key: string): string => translate(`utils.${key}`);
  return (
    <>
      <ReferenceArrayInput
        source={`${keyName}.services`}
        reference='paymentServices'
        basePath={basePath}
        label={t('remittancePayoutServices')}
        style={{ maxWidth: 600 }}
        perPage={1000}
        validate={required()}
      >
        <SelectArrayInput optionText={(r: any) => `${r?.name} (${r?.id})`} />
      </ReferenceArrayInput>
      <ReferenceArrayInput
        source={`${keyName}.accounts`}
        reference='tenant/accounts'
        basePath={basePath}
        label={t('tenantAccounts')}
        style={{ maxWidth: 600 }}
        perPage={100}
      >
        <SelectArrayInput optionText='alias' />
      </ReferenceArrayInput>
      <JsonInput
        label={t('remittancePayoutBeneficiarySchema')}
        source={`${keyName}.beneficiarySchema`}
        className={classes.schemaInput}
        validationError={t('jsonError')}
      />
      <JsonInput
        label={t('fastPayoutProfileSearchRules')}
        source={`${keyName}.fastPayoutProfileSearchRules`}
        className={classes.schemaInput}
        validationError={t('jsonError')}
        validationEmptyError={td('jsonEmptyArrayObjectError')}
        initialValue='[]'
        defaultValue='[]'
      />
      <TextInput
        source={`${keyName}.fastPayoutEligibilityCheckConnectionKey`}
        label={t('fastPayoutEligibilityCheckConnectionKey')}
        style={{ width: 600 }}
      />
    </>
  );
};
